export * from './LinkedCredential';
export * from './ReadonlyLinkedCredential';
